import { colors } from '@gto/ui/theme/design-tokens'

export const couponTagColorOptions = [
  {
    value: colors.primary.main,
    className: 'bg-primary-main text-primary-contrastText',
  },
  {
    value: colors.colorDots.pink,
    className: null,
  },
  {
    value: colors.info.main,
    className: 'bg-info-main text-info-contrastText',
  },
  {
    value: colors.deepPurple[400],
    className: 'bg-deep-purple-400 text-white',
  },
  {
    value: colors.warning.main,
    className: 'bg-warning-main text-warning-contrastText',
  },
  {
    value: colors.grey[500],
    className: 'bg-grey-500 text-primary-contrastText',
  },
  {
    value: colors.error.main,
    className: 'bg-error-main text-error-contrastText',
  },
  {
    value: colors.colorDots.yellow,
    className: null,
  },
] as const

export type CouponTagColor = (typeof couponTagColorOptions)[number]['value']

export const DEFAULT_COUPON_TAG_COLOR = couponTagColorOptions[0].value

export const getCouponTagColorClassName = (colorHex: string) =>
  couponTagColorOptions.find((option) => option.value === colorHex)?.className ?? null

const HEX_COLOR = /^#[\dA-F]{6}$/i

const linearChannel = (hex: string, start: number) => {
  const channel = Number.parseInt(hex.slice(start, start + 2), 16) / 255

  return channel <= 0.04045 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4
}

const relativeLuminance = (hex: string) => {
  if (!HEX_COLOR.test(hex)) {
    return 0
  }

  return (
    0.2126 * linearChannel(hex, 1) + 0.7152 * linearChannel(hex, 3) + 0.0722 * linearChannel(hex, 5)
  )
}

export const getTagForegroundColor = (backgroundColor: string) => {
  const backgroundLuminance = relativeLuminance(backgroundColor)
  const darkContrast = (backgroundLuminance + 0.05) / 0.05
  const lightContrast = 1.05 / (backgroundLuminance + 0.05)

  return darkContrast >= lightContrast ? colors.primary.contrastText : colors.text.primary
}
